import { render, staticRenderFns } from "./AnnotationPreview.vue?vue&type=template&id=a42c271a&scoped=true"
import script from "./AnnotationPreview.vue?vue&type=script&lang=js"
export * from "./AnnotationPreview.vue?vue&type=script&lang=js"
import style0 from "./AnnotationPreview.vue?vue&type=style&index=0&id=a42c271a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42c271a",
  null
  
)

export default component.exports